import React from "react";
import Breadcrumbs from "../../../../../../components/Breadcrumbs";

import UserDashboardHeader from "../../../../../../components/Administration/Jobs/UserJobs/UserDashboardHeader";
import DashboardWidget from "./DashboardWidget";
import DashboardGraph from "./DashboardGraph";
import OfferedJobs from "./OfferedJobs";
import DeleteModal from "../../../../../../components/modelpopup/deletePopup";
import AppliedJobsTable from "./AppliedJobsTable";

import { useTranslation } from "react-i18next";

const UserDashboard = () => {

  const { t } = useTranslation();

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t('User Job Dashboard')}
          title="Dashboard"
          subtitle={t('Jobs')+' / '+t('User Dashboard')}
        />
        <UserDashboardHeader />
        <DashboardWidget />
        <DashboardGraph />
        <OfferedJobs />
        <AppliedJobsTable />
        <DeleteModal Name={t('Delete')} />
      </div>
    </div>
  );
};

export default UserDashboard;
